import type {
  IFranchiseDataIncoming,
  IFranchiseTableData
} from "@dealer-center/ddc-pages-franchise-management-interface";

export const flattenFranchiseData = (
  data: IFranchiseDataIncoming[]
): IFranchiseTableData[] => {
  return data
    .map((item, i) => {
      return {
        id: item.id,
        name: item.name,
        abbreviation: item.abbreviation,
        created: item.audit.created,
        lastModified: item.audit.lastModified,
        formattedCreated: formatDateRecord(item.audit.created),
        formattedLastModified: formatDateRecord(item.audit.lastModified)
      };
    })
    .sort((a, b) => {
      return new Date(b.created).getTime() - new Date(a.created).getTime();
    });
};

export function formatDateRecord(date: string): string {
  if (!date) {
    return "N/A";
  }

  let normalizedDate = date;
  if (date.endsWith("+0000")) {
    normalizedDate = date.replace("+0000", "Z");
  }

  const parsedDate = new Date(normalizedDate);

  // Check if date is valid
  if (isNaN(parsedDate.getTime())) {
    console.warn(`Invalid date format: ${date}`);
    return "Invalid Date";
  }

  const options: Intl.DateTimeFormatOptions = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric"
  };

  return parsedDate.toLocaleString(undefined, options);
}
